import axios from 'axios';
import { getAccessTokenJWT } from 'utils/okta';
import { getExternalAccessTokenJWT } from 'utils/externalAccess';
import { appConfig } from 'config/appConfig';
import okta from 'constants/okta';

const APIEndpoint = 'Mailer';

export const sendEmails = async (from, tos, subject, content, attachments) => {

    return axios({
        method: 'post',
        url: appConfig.API_URL + '/' + APIEndpoint + '/Send',
        data: {
            from: from,
            tos: tos,
            subject: subject,
            htmlContext: content,
            attachments: attachments
        },
        headers: {
            Authorization: okta.Bearer + (getAccessTokenJWT() ? getAccessTokenJWT() : getExternalAccessTokenJWT()),
            'subscription-key': appConfig.API_SUBSCRIPTION_KEY,
        },
    })
        .then((response) => response.data)
        .catch((error) => {
            // TO-DO. Logging
            // control 401. okta redirection
            console.error(error);
            throw Error(error);
        });
};
